module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page wallet"
  }, [_c('mu-refresh-control', {
    attrs: {
      "refreshing": _vm.refreshing,
      "trigger": _vm.trigger
    },
    on: {
      "refresh": _vm.refresh
    }
  }), _vm._v(" "), _c('pageTitle', {
    attrs: {
      "title": "K币明细"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mycoin"
  }, [_vm._v("\n        我的K币\n        "), _c('h2', [_vm._v(_vm._s(_vm.wallet.KCoin))])]), _vm._v(" "), _c('div', {
    staticClass: "demo-refresh-container"
  }, [_c('div', {
    staticClass: "list"
  }, _vm._l((_vm.coinRecords), function(item) {
    return _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.deleteitem(item.logID)
        }
      }
    }, [_c('div', {
      staticClass: "date"
    }, [_vm._v("\n                    " + _vm._s(_vm._f("detailDate")(item.Operate_Date)) + "\n                ")]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "strong"
    }, [_vm._v(_vm._s(item.Operate_Type_Display))]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "detail"
    }, [_vm._v("备注:" + _vm._s(_vm._f("remark")(item.Operate_Remark)))])]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm._f("discount")(item.Operate_Money)))])])])
  }), 0), _vm._v(" "), _c('loadListTail', {
    attrs: {
      "mainTitle": "暂无K币记录",
      "mainIcon": "noDetail",
      "noMore": _vm.loadState.stop,
      "isLoading": _vm.loadState.loading,
      "overZero": _vm.coinRecords.length > 0
    }
  }), _vm._v(" "), (_vm.loadState.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/LoadingBest.gif")
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.dialog,
      "title": ""
    },
    on: {
      "close": _vm.closeNO
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#666666",
      "margin-bottom": "1.5vh"
    }
  }, [_vm._v("\n            您真的要删除这条记录吗？\n        ")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-flat-button', {
    staticStyle: {
      "background-color": "#cccccc",
      "color": "white"
    },
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "取消"
    },
    on: {
      "click": _vm.closeNO
    },
    slot: "actions"
  })], 1), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-flat-button', {
    staticStyle: {
      "background-color": "#27BA69",
      "color": "white"
    },
    attrs: {
      "slot": "actions",
      "label": "确定"
    },
    on: {
      "click": _vm.closeYES
    },
    slot: "actions"
  })], 1)])])]), _vm._v(" "), (_vm.toast) ? _c('mu-toast', {
    attrs: {
      "message": _vm.TellUser,
      "id": "alertline"
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-780ea5c5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/wallet/coinDetail.vue
// module id = 1550
// module chunks = 18